import './CalendarPickerView.less'
import CalendarPickerView  from './CalendarPickerView'

export type {
  CalendarPickerViewProps,
  // CalendarPickerViewRef,
} from './iCalendarPickerView'

export default CalendarPickerView
